import React from 'react';
import { Box, Typography } from '@mui/material';


export default function HowItWorks() {




  return (
    <Box sx={{ width: '100%', pt: 4, pb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#0F231A' }}>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          color: '#ddd',
          mb: 1,
          textAlign: 'center',
          fontSize: '16px',
          fontFamily: '"Plus Jakarta Sans", sans-serif'
        }}
      >
        Follow These Steps To Complete Task:
      </Typography>

      <Box sx={{ position: 'relative', mt: 1 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: '#fff', // White color for dark theme
            textAlign: 'center',
            zIndex: 1,
            position: 'relative',
            fontFamily: '"Moan Slight", sans-serif',
            fontSize: '28px'
          }}
        >
          Install & Register <span style={{ position: 'relative', display: 'inline-block' }}>
            this app
          </span>
        </Typography>
      </Box>


    </Box>
  );
}
